import $ from 'jquery';
import countdown from 'jquery-countdown';


$('[data-countdown]').each(function() {
  var $this = $(this), finalDate = $(this).data('countdown');
  $this.countdown(finalDate, function(event) {
    var $this = $(this).html(event.strftime(''
      + '<div class="col-4 col-lg-auto"><div class="countdown"><p class="countdown-value">%D</p><p class="countdown-label">days</p></div></div>'
      + '<div class="col-4 col-lg-auto"><div class="countdown"><p class="countdown-value">%H</p><p class="countdown-label">hours</p></div></div>'
      + '<div class="col-4 col-lg-auto"><div class="countdown"><p class="countdown-value">%M</p><p class="countdown-label">mins</p></div></div>'));
  });
});
